import { Breakpoints, styled } from "@vw-marketing/us-components";

export const RelatedContentWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      padding-top: ${theme.size.static200};
      width: calc(100vw - 8.3vw);

      @media (min-width: 600px) {
        padding-top: ${theme.size.static350};
        width: 100%;
      }
    `;
  }}
`;

export const RelatedContentTitleContainer: any = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  gap: 10px;
`

export const RelatedContentCardsWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      padding-top: ${theme.size.static350};
      width: 100%;

      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static400};
      }
    `;
  }}
`;

export const RelatedContentCardsContainer: any = styled.div`
  ${({ theme }) => {
    return`
      width: 100%;

      @media (min-width: ${Breakpoints.b560}px) {
        display: flex;
        gap: ${theme.size.static350};
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: ${theme.size.static550};
      }
    `;
  }}
`;

export const StyledLentilsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: center;
      background-color: transparent;
      display: flex;
      justify-content: center;
      padding: ${theme.size.dynamic0050};
      width: 100%;
    `
  }}
`;